<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <!--供应商投标操作流程详情-->
        <div v-if="isDetail">
          <div class="page-title">{{ $t("page.sup.dialog.title") }}</div>
          <el-divider></el-divider>
          <div class="">
            <h5 class="dialogTitle">
              {{ $t("page.sup.dialog.dialogTitle") }}
            </h5>
            <ul>
              <li class="ul-items">
                <span>{{ $t("page.sup.dialog.content1") }}</span>
                <p>{{ $t("page.sup.dialog.contentP1") }}</p>
              </li>
              <li class="ul-items">
                <span>{{ $t("page.sup.dialog.content2") }}</span>
                <p>
                  {{ $t("page.sup.dialog.contentP2") }}
                </p>
              </li>
              <li class="ul-items">
                <span>{{ $t("page.sup.dialog.content3") }}</span>
                <p style="margin-bottom:20px">
                  {{ $t("page.sup.dialog.contentP3") }}
                </p>
                <ul class="tenderOperation">
                  <li>
                    {{ $t("page.sup.dialog.participateInBidd") }}
                    <span class="expand" @click="toggleShowClick1()">{{
                      toggleShow1
                    }}</span>
                    <div v-show="participateInBidd">
                      <p>{{ $t("page.sup.dialog.participateInBiddCont1") }}</p>
                      <p>
                        {{ $t("page.sup.dialog.participateInBiddCont2") }}
                      </p>
                    </div>
                  </li>
                  <li>
                    {{ $t("page.sup.dialog.biddingDocuments") }}
                    <span class="expand" @click="toggleShowClick2()">{{
                      toggleShow2
                    }}</span>
                    <div v-show="downloadTenderDocuments">
                      <p>
                        {{ $t("page.sup.dialog.biddingDocumentsCont1") }}
                      </p>
                      <p>{{ $t("page.sup.dialog.biddingDocumentsCont2") }}</p>
                    </div>
                  </li>
                  <li>
                    {{ $t("page.sup.dialog.tender") }}
                    <span class="expand" @click="toggleShowClick3()">{{
                      toggleShow3
                    }}</span>
                    <div v-show="tender">
                      <p>{{ $t("page.sup.dialog.tenderCont1") }}</p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont2") }}
                      </p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont3") }}
                      </p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont4") }}
                      </p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont5")
                        }}<span class="aTender"
                          >“{{ $t("page.sup.dialog.aTender") }}”</span
                        >。
                      </p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont6") }}
                        <span class="aTender"
                          >“{{ $t("page.sup.dialog.reportAgain") }}”</span
                        >
                        {{ $t("page.sup.dialog.tenderCont7") }}
                      </p>
                      <p>
                        {{ $t("page.sup.dialog.tenderCont8") }}
                      </p>
                    </div>
                  </li>
                  <li>
                    {{ $t("page.sup.dialog.toClarify") }}
                    <span class="expand" @click="toggleShowClick4()">{{
                      toggleShow4
                    }}</span>
                    <div v-show="toClarify">
                      <p>
                        {{ $t("page.sup.dialog.toClarifyCont") }}
                      </p>
                    </div>
                  </li>
                  <li>
                    {{ $t("page.sup.dialog.question") }}
                    <span class="expand" @click="toggleShowClick5()">{{
                      toggleShow5
                    }}</span>
                    <div v-show="question">
                      <p>
                        {{ $t("page.sup.dialog.questionCont") }}
                      </p>
                    </div>
                  </li>
                  <li>
                    {{ $t("page.sup.dialog.addendumFile") }}
                    <span class="expand" @click="toggleShowClick6()">{{
                      toggleShow6
                    }}</span>
                    <div v-show="addendumFile">
                      <p>
                        {{ $t("page.sup.dialog.addendumFileCont") }}
                      </p>
                    </div>
                  </li>
                </ul>
              </li>
              <li class="ul-items">
                <div>
                  {{ $t("page.sup.dialog.notes") }}
                  <span class="expand" @click="toggleShowClick7()">{{
                    toggleShow7
                  }}</span>
                  <div v-show="notes">
                    <p class="aTender" style="text-indent:2em;margin: 10px 0;">
                      {{ $t("page.sup.dialog.notesCont1") }}
                    </p>
                    <ul>
                      <li style="margin-bottom:20px">
                        <p>{{ $t("page.sup.dialog.notesCont2") }}</p>
                        <p>
                          {{ $t("page.sup.dialog.notesCont3") }}
                        </p>
                        <p>
                          {{ $t("page.sup.dialog.notesCont4") }}（<a
                            href="http://www.pdfforge.org/download"
                            target="_blank"
                            style="color:#0089ef;"
                            >{{ $t("page.sup.dialog.click") }}</a
                          >）
                        </p>
                      </li>
                      <li>
                        <p>
                          {{ $t("page.sup.dialog.notesCont5") }}
                        </p>
                        <p>
                          {{ $t("page.sup.dialog.notesCont6") }}
                          <span class="aTender">PDF</span>。
                        </p>
                        <p>
                          {{ $t("page.sup.dialog.notesCont7") }}——<span
                            class="aTender"
                            >{{ $t("page.sup.dialog.smallestFileSize") }}</span
                          >”，{{ $t("page.sup.dialog.notesCont8") }}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--供应商投标操作流程-->
        <div v-else>
          <div class="dic-view">
            <div class="title-box">
              <span class="content-title" :title="faqProblemBO.faqName">
                {{ faqProblemBO.faqName }}
              </span>
            </div>
            <div class="little-title">
              <span>
                {{
                  `${$t("page.sup.releaseMechanism")}${
                    faqProblemBO.createUserName
                  }`
                }}</span
              >
              <span>{{
                `${$t("page.sup.releaseTime")}${faqProblemBO.publishTime}`
              }}</span>
            </div>
            <div class="content-detail">
              <span class="titleContent">
                {{ $t("page.sup.titleContent") }}
              </span>
              <div>
                <p>
                  {{ $t("page.sup.titleContent1") }}
                </p>
                <p>
                  {{ $t("page.sup.titleContent2") }}
                </p>
                <p>
                  {{ $t("page.sup.titleContent3") }}
                </p>
                <p>
                  {{ $t("page.sup.titleContent4")
                  }}<span @click="operationProcess" class="titleContentLink">{{
                    $t("page.sup.operationProcess")
                  }}</span
                  ><span class="linkHint"
                    >（{{ $t("page.sup.clickOnTitleToView") }}）</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!--附件列表-->
          <el-group-title :title="$t('page.sup.table.title')" class="mt20">
            <template slot="groupTitle">
              <el-table
                :show-overflow-tooltip="true"
                :data="activities"
                border
                lazy
                row-key="id"
                style="width: 100%"
                :empty-text="$t('page.content.noData')"
              >
                <el-table-column
                  :show-overflow-tooltip="true"
                  :label="$t('page.sup.table.serialNumber')"
                  prop="id"
                  width="50"
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  :label="$t('page.sup.table.fileName')"
                  prop="name"
                  width=""
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  :label="$t('page.sup.table.fileSize')"
                  prop="name"
                  width=""
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  :label="$t('page.sup.table.fileDesc')"
                  prop="name"
                  width=""
                />
                <el-table-column
                  :label="$t('page.sup.table.operation')"
                  width="170"
                >
                  <el-button size="mini" type="text">{{
                    $t("page.sup.table.upload")
                  }}</el-button>
                </el-table-column>
              </el-table>
            </template>
          </el-group-title>
        </div>
      </div>

      <!--<el-dialog
        :title="$t('page.sup.dialog.title')"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="handleClose"
      >

      </el-dialog>-->
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
export default {
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      faqProblemBO: {
        faqName: window.$t("page.sup.faqName"),
        publishTime: "2014-05-10",
        createUserName: window.$t("page.sup.createUserName"),
        readingCnt: "",
        publishUser: "",
        faqId: "",
        textContent: ""
      },
      toggleShow1: window.$t("page.sup.dialog.spread"),
      toggleShow2: window.$t("page.sup.dialog.spread"),
      toggleShow3: window.$t("page.sup.dialog.spread"),
      toggleShow4: window.$t("page.sup.dialog.spread"),
      toggleShow5: window.$t("page.sup.dialog.spread"),
      toggleShow6: window.$t("page.sup.dialog.spread"),
      toggleShow7: window.$t("page.sup.dialog.spread"),
      participateInBidd: false,
      downloadTenderDocuments: false,
      tender: false,
      toClarify: false,
      question: false,
      addendumFile: false,
      notes: false,
      dialogVisible: false,
      dialogImageUrl: "",
      activities: [
        // {
        //   id: "02",
        //   name: "营业执照副本图片.txt",
        //   operation: "下载",
        //   img:
        //     "data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI0NHB4IiBoZWlnaHQ9IjQ0cHgiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNDQgNDQiIHhtbDpzcGFjZT0icHJlc2VydmUiPiAgPGltYWdlIGlkPSJpbWFnZTAiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgeD0iMCIgeT0iMCIKICAgIGhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBQ3dBQUFBc0NBTUFBQUFwV3FvekFBQUFCR2RCVFVFQUFMR1BDL3hoQlFBQUFDQmpTRkpOCkFBQjZKZ0FBZ0lRQUFQb0FBQUNBNkFBQWRUQUFBT3BnQUFBNm1BQUFGM0NjdWxFOEFBQUFpbEJNVkVYdTcvTWJ1KzhjdSs3dDd2UEEKNC9LdTN2Sk14L0FJdCs1NjB2Rkh4KzlIeHU4endlL3A3Zk9rM2ZGSHlmSk55L0k2eGZBM3hQRXF3ZkEwdy9BVnV1NU95L0tyNXZsMwoxL1UyeFBHeTZQbSs3UG9xd085VnpmUE04UHNYdSsrRTIvWTR4ZkVpdnUvdCtmMUV5UEsxNmZsYXovTzQ2dnFGMi9ZZ3Z1Kzg2L29MCnVPNmk0L2creHZILy8vL1hkLytwQUFBQUEzUlNUbFBxL2YwOEhZRDVBQUFBQVdKTFIwUXR6ZHBCUFFBQUFBZDBTVTFGQitNRkZnQUgKT3gvY08xd0FBQUNGU1VSQlZEakw3ZEM1R29Jd0VJWFJvT2cxS0l3bzRNYmlyaXp2LzN5a1M0V1orS21OK1pzMHA3Z1RJY2JzaElWVgoydUdQWVgraU0rSXBkRVk4azFJR3dGdzlrclY1QVlUc0F4MytLenlVdys5aldQUkRIQkV0WTZ6V1JKUVljWnB0dHJ0NGY4aUx2RFRQCnFJNDRuUy9BbGJOWjRkdjl3Y2JQdW1rN0h2N2ExNzNFSHQrT2VpR0dKRFVCaEk2a0FBQUFKWFJGV0hSa1lYUmxPbU55WldGMFpRQXkKTURFNUxUQTFMVEl4VkRFMk9qQTNPalU1S3pBNE9qQXdWemJYYVFBQUFDVjBSVmgwWkdGMFpUcHRiMlJwWm5rQU1qQXhPUzB3TlMweQpNVlF4Tmpvd056bzFPU3N3T0Rvd01DWnJiOVVBQUFBQVNVVk9SSzVDWUlJPSIgLz4KPC9zdmc+Cg=="
        // },
        // {
        //   id: "03",
        //   name: "营业执照副本图片.word",
        //   operation: "下载",
        //   img:
        //     "data:image/svg+xml;base64,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"
        // }
      ],
      currBreadCrumb: [
        {
          title: this.$t("page.content.supplierOperationGuide"),
          path: "/operationManual"
        },
        { title: this.$t("page.sup.faqName") }
      ],
      isDetail: false
    };
  },
  created() {
    // this.queryFaqProblemById(this.$route.query.faqId);
  },
  methods: {
    // // 详情接口服务
    // queryFaqProblemById(faqId) {
    //   queryFaqProblemById({ faqId: faqId }).then(res => {
    //     this.faqClassifyName = res.data.data.faqClassifyName;
    //     this.faqProblemBO = res.data.data.faqProblemBO;
    //     this.faqId = res.data.data.faqProblemBO.faqId;
    //   });
    // }
    operationProcess() {
      // this.dialogVisible = true;
      this.isDetail = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    toggleShowClick1() {
      if (this.toggleShow1 === window.$t("page.sup.dialog.spread")) {
        this.participateInBidd = true;
        this.toggleShow1 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.participateInBidd = false;
        this.toggleShow1 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick2() {
      if (this.toggleShow2 === window.$t("page.sup.dialog.spread")) {
        this.downloadTenderDocuments = true;
        this.toggleShow2 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.downloadTenderDocuments = false;
        this.toggleShow2 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick3() {
      if (this.toggleShow3 === window.$t("page.sup.dialog.spread")) {
        this.tender = true;
        this.toggleShow3 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.tender = false;
        this.toggleShow3 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick4() {
      if (this.toggleShow4 === window.$t("page.sup.dialog.spread")) {
        this.toClarify = true;
        this.toggleShow4 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.toClarify = false;
        this.toggleShow4 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick5() {
      if (this.toggleShow5 === window.$t("page.sup.dialog.spread")) {
        this.question = true;
        this.toggleShow5 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.question = false;
        this.toggleShow5 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick6() {
      if (this.toggleShow6 === window.$t("page.sup.dialog.spread")) {
        this.addendumFile = true;
        this.toggleShow6 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.addendumFile = false;
        this.toggleShow6 = window.$t("page.sup.dialog.spread");
      }
    },
    toggleShowClick7() {
      if (this.toggleShow7 === window.$t("page.sup.dialog.spread")) {
        this.notes = true;
        this.toggleShow7 = window.$t("page.sup.dialog.shrinkage");
      } else {
        this.notes = false;
        this.toggleShow7 = window.$t("page.sup.dialog.spread");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/variables.scss";
@import "~@/config/styles/question-edit.scss";
.mt20 {
  margin-top: 20px;
}
.content-detail {
  padding-top: 20px;
  border-top: 1px solid #f1f1f1;
  font-size: 12px;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  .titleContent {
    display: inline-block;
    margin-bottom: 20px;
  }
  .titleContentLink {
    font-size: 12px;
    color: #0089ef;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 400;
    cursor: pointer;
    padding-bottom: 3px;
    border-bottom: 1px solid #0089ef;
  }
  .linkHint {
    color: #d5090b;
  }
}
.dialogTitle {
  font-size: 13px;
  color: #4a4a4a;
}
.ccui-app-container-detail-body > ul {
  margin-top: 20px;
}
.ccui-app-container-detail-body > ul > li {
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 20px;
}
.tenderOperation p {
  padding: 5px 0;
}
.aTender {
  color: #ff0000;
}
.expand {
  font-size: 13px;
  color: #0089ef;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  cursor: pointer;
}
</style>
